import {
  StyleParamType,
  createStylesParams,
  wixColorParam,
  wixFontParam,
  type IStyleParam,
  type IStyleParamValuesByType,
} from '@wix/tpa-settings';
import { Alignment } from 'root/consts';
import {
  stylesParams as menusStylesParams,
  customCssVars,
  type IStylesParams as IMenusStylesParams,
  type StylesParamsType,
} from 'root/components/Menus/stylesParams';
import {
  DEFAULT_BACKGROUND_HORIZONTAL_PADDING,
  DEFAULT_BACKGROUND_VERTICAL_PADDING,
  DEFAULT_ITEMS_COLUMN_GAP,
  DEFAULT_ITEMS_PER_LOAD,
  DEFAULT_ITEMS_ROW_GAP,
  DEFAULT_FEATURED_BADGE_PLACEMENT,
  DEFAULT_ITEM_IMAGE_RATIO,
  DEFAULT_ITEM_IMAGE_RESIZE_MODE,
  DEFAULT_ITEM_IMAGE_SIDE_PADDING,
  DEFAULT_ITEM_IMAGE_VERTICAL_PADDING,
  DEFAULT_ITEM_INFO_SIDE_PADDING,
  DEFAULT_ITEM_VERTICAL_PADDING,
  DEFAULT_MAX_ITEMS_PER_ROW,
  DEFAULT_SLIDER_ARROW_DISTANCE,
  MenuAddOnItemsDisplayMode,
  MenuAddOnSliderArrowPosition,
} from 'root/components/MenuAddOn/Settings/Tabs/LayoutTab/consts';

export type IMenuAddOnOnlyStylesParams = {
  menuAddOnHeaderAlignment: StyleParamType.Number;
  menuAddOnMaxItemsPerRow: StyleParamType.Number;
  menuAddOnItemsDisplayMode: StyleParamType.Number;
  menuAddOnItemsPerLoad: StyleParamType.Number;
  menuAddOnItemsColumnGap: StyleParamType.Number;
  menuAddOnItemsRowGap: StyleParamType.Number;
  menuAddOnCardAlignment: StyleParamType.Number;
  menuAddOnBackgroundHorizontalPadding: StyleParamType.Number;
  menuAddOnBackgroundVerticalPadding: StyleParamType.Number;
  menuAddOnSliderArrowDistance: StyleParamType.Number;
  menuAddOnSliderArrowPosition: StyleParamType.Number;
  menuAddOnSliderArrowSize: StyleParamType.Number;
  menuAddOnSliderArrowColor: StyleParamType.Color;
  menuAddOnSliderArrowContainerColor: StyleParamType.Color;
  menuAddOnSliderArrowContainerBorderRadius: StyleParamType.Number;
  menuAddOnSliderArrowContainerBorderWidth: StyleParamType.Number;
  menuAddOnSliderArrowContainerBorderColor: StyleParamType.Color;
  menuAddOnItemInfoSidePadding: StyleParamType.Number;
  menuAddOnItemVerticalPadding: StyleParamType.Number;
  menuAddOnItemInfoAlignment: StyleParamType.Number;
  menuAddOnItemImageRatio: StyleParamType.Number;
  menuAddOnItemImageResizeMode: StyleParamType.Number;
  menuAddOnItemImageVerticalPadding: StyleParamType.Number;
  menuAddOnItemImageSidePadding: StyleParamType.Number;
  menuAddOnItemImageOpacity: StyleParamType.Number;
  menuAddOnItemImageBackgroundColor: StyleParamType.Color;
  menuAddOnFeaturedBadgePlacement: StyleParamType.Number;
  menuAddOnViewFullMenuButtonAlignment: StyleParamType.Number;
  menuAddOnViewFullMenuButtonStyle: StyleParamType.Number;
  menuAddOnViewFullMenuButtonBorderRadius: StyleParamType.Number;
  menuAddOnViewFullMenuButtonBackgroundColor: StyleParamType.Color;
  menuAddOnViewFullMenuButtonBorderWidth: StyleParamType.Number;
  menuAddOnViewFullMenuButtonBorderColor: StyleParamType.Color;
  menuAddOnViewFullMenuButtonTextColor: StyleParamType.Color;
  menuAddOnViewFullMenuButtonTextTheme: StyleParamType.Font;
  menuAddOnViewFullMenuButtonHoverBackgroundColor: StyleParamType.Color;
  menuAddOnViewFullMenuButtonHoverBorderColor: StyleParamType.Color;
  menuAddOnViewFullMenuButtonHoverTextColor: StyleParamType.Color;
  menuAddOnViewFullMenuButtonHoverTextTheme: StyleParamType.Font;
  menuAddOnLoadMoreButtonAlignment: StyleParamType.Number;
  menuAddOnLoadMoreButtonTextColor: StyleParamType.Color;
  menuAddOnLoadMoreButtonTextTheme: StyleParamType.Font;
  menuAddOnAddToCartButtonAlignment: StyleParamType.Number;
  menuAddOnAddToCartButtonStyle: StyleParamType.Number;
  menuAddOnAddToCartButtonContent: StyleParamType.Number;
  menuAddOnAddToCartButtonIconType: StyleParamType.Number;
  menuAddOnAddToCartButtonWidth: StyleParamType.Number;
  menuAddOnAddToCartButtonDefaultTextTheme: StyleParamType.Font;
  menuAddOnAddToCartButtonDefaultTextColor: StyleParamType.Color;
  menuAddOnAddToCartButtonDefaultBackgroundColor: StyleParamType.Color;
  menuAddOnAddToCartButtonDefaultBorderWidth: StyleParamType.Number;
  menuAddOnAddToCartButtonDefaultBorderColor: StyleParamType.Color;
  menuAddOnAddToCartButtonHoverTextTheme: StyleParamType.Font;
  menuAddOnAddToCartButtonHoverTextColor: StyleParamType.Color;
  menuAddOnAddToCartButtonHoverBackgroundColor: StyleParamType.Color;
  menuAddOnAddToCartButtonHoverBorderColor: StyleParamType.Color;
  menuAddOnAddToCartButtonBorderRadiusStartStart: StyleParamType.Number;
  menuAddOnAddToCartButtonBorderRadiusStartEnd: StyleParamType.Number;
  menuAddOnAddToCartButtonBorderRadiusEndStart: StyleParamType.Number;
  menuAddOnAddToCartButtonBorderRadiusEndEnd: StyleParamType.Number;
  menuAddOnAddToCartButtonBorderRadiusLinked: StyleParamType.Number;
  menuAddOnOrderingBannerTextTheme: StyleParamType.Font;
  menuAddOnOrderingBannerTextColor: StyleParamType.Color;
  menuAddOnOrderingBannerShowIcon: StyleParamType.Boolean;
  menuAddOnOrderingBannerIconColor: StyleParamType.Color;
  menuAddOnOrderingBannerIconSize: StyleParamType.Number;
  menuAddOnOrderingBannerChangeButtonTextTheme: StyleParamType.Font;
  menuAddOnOrderingBannerChangeButtonTextColor: StyleParamType.Color;
  menuAddOnOrderingBannerChangeButtonBackgroundColor: StyleParamType.Color;
  menuAddOnOrderingBannerChangeButtonBorderColor: StyleParamType.Color;
  menuAddOnOrderingBannerChangeButtonBorderWidth: StyleParamType.Number;
  menuAddOnOrderingBannerChangeButtonBorderRadius: StyleParamType.Number;
  menuAddOnOrderingBannerViewCartButtonTextTheme: StyleParamType.Font;
  menuAddOnOrderingBannerViewCartButtonTextColor: StyleParamType.Color;
  menuAddOnOrderingBannerViewCartButtonBackgroundColor: StyleParamType.Color;
  menuAddOnOrderingBannerViewCartButtonBorderColor: StyleParamType.Color;
  menuAddOnOrderingBannerViewCartButtonBorderWidth: StyleParamType.Number;
  menuAddOnOrderingBannerViewCartButtonBorderRadius: StyleParamType.Number;
  menuAddOnOrderingBannerBackgroundColor: StyleParamType.Color;
  menuAddOnOrderingBannerBorderColor: StyleParamType.Color;
  menuAddOnOrderingBannerBorderWidth: StyleParamType.Number;
  menuAddOnOrderingBannerBorderRadius: StyleParamType.Number;
};

const menuAddOnOnlyStylesParams = createStylesParams<IMenuAddOnOnlyStylesParams>({
  menuAddOnHeaderAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  menuAddOnMaxItemsPerRow: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_MAX_ITEMS_PER_ROW,
  },
  menuAddOnItemsDisplayMode: {
    type: StyleParamType.Number,
    getDefaultValue: () => MenuAddOnItemsDisplayMode.Grid,
  },
  menuAddOnItemsPerLoad: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_ITEMS_PER_LOAD,
  },
  menuAddOnItemsColumnGap: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_ITEMS_COLUMN_GAP,
  },
  menuAddOnItemsRowGap: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_ITEMS_ROW_GAP,
  },
  menuAddOnCardAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Start,
  },
  menuAddOnBackgroundHorizontalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_BACKGROUND_HORIZONTAL_PADDING,
  },
  menuAddOnBackgroundVerticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_BACKGROUND_VERTICAL_PADDING,
  },
  menuAddOnSliderArrowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_SLIDER_ARROW_DISTANCE,
  },
  menuAddOnSliderArrowPosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => MenuAddOnSliderArrowPosition.Inside,
  },
  menuAddOnSliderArrowSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 24,
  },
  menuAddOnSliderArrowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  menuAddOnSliderArrowContainerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  menuAddOnSliderArrowContainerBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 50,
  },
  menuAddOnSliderArrowContainerBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnSliderArrowContainerBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0),
  },
  menuAddOnItemInfoSidePadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_ITEM_INFO_SIDE_PADDING,
  },
  menuAddOnItemVerticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_ITEM_VERTICAL_PADDING,
  },
  menuAddOnItemInfoAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Start,
  },
  menuAddOnItemImageRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_ITEM_IMAGE_RATIO,
  },
  menuAddOnItemImageResizeMode: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_ITEM_IMAGE_RESIZE_MODE,
  },
  menuAddOnItemImageVerticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_ITEM_IMAGE_VERTICAL_PADDING,
  },
  menuAddOnItemImageSidePadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_ITEM_IMAGE_SIDE_PADDING,
  },
  menuAddOnItemImageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
  },
  menuAddOnItemImageBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0),
  },
  menuAddOnFeaturedBadgePlacement: {
    type: StyleParamType.Number,
    getDefaultValue: () => DEFAULT_FEATURED_BADGE_PLACEMENT,
  },
  menuAddOnViewFullMenuButtonAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  menuAddOnViewFullMenuButtonStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  menuAddOnViewFullMenuButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnViewFullMenuButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action', 0),
  },
  menuAddOnViewFullMenuButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  menuAddOnViewFullMenuButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
  },
  menuAddOnViewFullMenuButtonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
  },
  menuAddOnViewFullMenuButtonTextTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  menuAddOnViewFullMenuButtonHoverBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action', 0),
  },
  menuAddOnViewFullMenuButtonHoverBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
  },
  menuAddOnViewFullMenuButtonHoverTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action'),
  },
  menuAddOnViewFullMenuButtonHoverTextTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  menuAddOnLoadMoreButtonAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  menuAddOnLoadMoreButtonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  menuAddOnLoadMoreButtonTextTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
      fontStyleParam: true,
      style: { bold: false, italic: false, underline: true },
    }),
  },
  menuAddOnAddToCartButtonAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Center,
  },
  menuAddOnAddToCartButtonStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnAddToCartButtonContent: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnAddToCartButtonIconType: {
    type: StyleParamType.Number,
    getDefaultValue: () => 4,
  },
  menuAddOnAddToCartButtonWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnAddToCartButtonDefaultTextTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  menuAddOnAddToCartButtonDefaultTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-text-primary'),
  },
  menuAddOnAddToCartButtonDefaultBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-fill-primary'),
  },
  menuAddOnAddToCartButtonDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnAddToCartButtonDefaultBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary', 0.12),
  },
  menuAddOnAddToCartButtonHoverTextTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  menuAddOnAddToCartButtonHoverTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  menuAddOnAddToCartButtonHoverBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  menuAddOnAddToCartButtonHoverBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
  },
  menuAddOnAddToCartButtonBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnAddToCartButtonBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnAddToCartButtonBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnAddToCartButtonBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnAddToCartButtonBorderRadiusLinked: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  menuAddOnOrderingBannerTextTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
      htmlTag: 'p',
    }),
  },
  menuAddOnOrderingBannerTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  menuAddOnOrderingBannerShowIcon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  menuAddOnOrderingBannerIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  menuAddOnOrderingBannerIconSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 24,
  },
  menuAddOnOrderingBannerChangeButtonTextTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  menuAddOnOrderingBannerChangeButtonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-fill-primary'),
  },
  menuAddOnOrderingBannerChangeButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
  },
  menuAddOnOrderingBannerChangeButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-fill-primary'),
  },
  menuAddOnOrderingBannerChangeButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  menuAddOnOrderingBannerChangeButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnOrderingBannerViewCartButtonTextTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  menuAddOnOrderingBannerViewCartButtonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-text-primary'),
  },
  menuAddOnOrderingBannerViewCartButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-fill-primary'),
  },
  menuAddOnOrderingBannerViewCartButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-fill-primary', 0),
  },
  menuAddOnOrderingBannerViewCartButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnOrderingBannerViewCartButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuAddOnOrderingBannerBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-fill-background-primary', 1),
  },
  menuAddOnOrderingBannerBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-fill-primary', 0.3),
  },
  menuAddOnOrderingBannerBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  menuAddOnOrderingBannerBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
});

export type IStylesParams = IMenusStylesParams & IMenuAddOnOnlyStylesParams;

export const stylesParams: StylesParamsType<IStylesParams> = {
  ...menusStylesParams,
  ...menuAddOnOnlyStylesParams,
};

export default stylesParams;
export { customCssVars };

export type StyleParamKey = keyof typeof stylesParams;
export type StyleParamValue = IStyleParamValuesByType[keyof IStyleParamValuesByType];

export type StyleParamsByType<T extends StyleParamType> = {
  [K in keyof IStylesParams as IStylesParams[K] extends T ? K : never]: IStylesParams[K];
};

export type StyleParamKeysByType<T extends StyleParamType> = keyof StyleParamsByType<T>;

export type ExtractStyleParamValue<T> = T extends IStyleParam<StyleParamType, infer U> ? U : never;
export type { StylesParamsType };
